const parseTimezoneDate = (date) => {
  const oldDate = new Date(date)
  const newDate = new Date()
  newDate.setTime(new Date(oldDate).getTime() + new Date(oldDate).getTimezoneOffset() * 60 * 1000)
  newDate.setHours(0, 0, 0, 0)

  return newDate
}

const addDateWeek = (date, limitDate) => {
  const start = new Date(date)
  const weekDay = start.getDay()

  if (weekDay === 0) return start

  const remainingDays = 7 - weekDay
  start.setDate(start.getDate() + remainingDays)

  return start < limitDate ? start : limitDate
}

const diffInDays = (startDate, endDate) => {
  const diffTime = new Date(endDate) - new Date(startDate)
  const MS_PER_DAY = 1000 * 60 * 60 * 24

  return Math.round(diffTime / MS_PER_DAY) + 1
}

const diffInWeeks = (startDate, endDate) => {
  const diffTime = new Date(endDate) - new Date(startDate)
  const MS_PER_WEEK = 1000 * 60 * 60 * 24 * 7

  return Math.round(diffTime / MS_PER_WEEK)
}

const diffInMonths = (dateFrom, dateTo) => {
  const date = {
    from: {
      month: dateFrom.getMonth(),
      year: dateFrom.getFullYear()
    },
    to: {
      month: dateTo.getMonth(),
      year: dateTo.getFullYear()
    }
  }

  const allMonthsOfYear = 12

  return date.to.month - date.from.month + (allMonthsOfYear * (date.to.year - date.from.year))
}

const isSameMonth = (startDate, endDate) => {
  const [startMonth, startYear] = [startDate.getMonth(), startDate.getFullYear()]
  const [endMonth, endYear] = [endDate.getMonth(), endDate.getFullYear()]

  const isEqualMonth = startMonth === endMonth
  const isEqualYear = startYear === endYear

  return isEqualMonth && isEqualYear
}

const daysInMonth = (date) => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1

  return new Date(year, month, 0).getDate()
}

export {
  parseTimezoneDate,
  addDateWeek,
  diffInDays,
  diffInMonths,
  isSameMonth,
  diffInWeeks,
  daysInMonth
}
